import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

export const useIsLoggedIn = (): boolean => {
  return useSelector((state: RootState) => Boolean(state.user?.isLoggedIn));
};

export default useIsLoggedIn;
